import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { LoginComponent } from './components/login/login.component';
import { RecoverPasswordComponent } from './components/recover-password/recover-password.component';
import { SetPasswordComponent } from './components/set-password/set-password.component';

@NgModule({
  declarations: [LoginComponent, SetPasswordComponent, RecoverPasswordComponent],
  imports: [SharedModule, RouterModule],
})
export class AuthenticationModule {}
